@if (captchaBase64ImageUrl) {
  <div class="field">
    <img [src]="captchaBase64ImageUrl" />
    <a href="javascript:void(0);" (click)="reload()" class="hyperlink">{{ 'TryANewCaptchaChallenge' | translate }}</a>
    @if (captchaBase64AudioUrl) {
      <audio controls [src]="captchaBase64AudioUrl" attr.aria-label="{{'ClickOrPressEnterToPlayCaptchaAudio' | translate}}"></audio>
    }
    <label class="label lm-captcha-label">{{ 'EnterTextInImage' | translate }}</label>
    <input type="text" [(ngModel)]="captchaValue" [ngClass]="{'error': isValid === false}" />
  </div>
}

